export default function(state = {}, action) {
  const typeMap = {
    INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        innovationByDesignScrollingModule:
          action.innovationByDesignScrollingModule
      };
    },
    INNOVATION_BY_DESIGN_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignScrollingModule
      };
    },
    INNOVATION_BY_DESIGN_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
